import { destroy, get, getOne, post, put } from "../apis/httpClient"

export const getProvince = () => get(`/api/v1/country/province`)